module.exports = __webpack_public_path__ + "static/media/urbangoo13.0be63bdb.webp";